export default __webpack_public_path__ + "static/media/idolofdarkrejuvenation.cec72844.png";